import {
  ENVIRONMENT,
  Environment,
  getCurrentEnvironment,
} from './environments';

export const enabledIn = (
  environments: readonly Environment[] | typeof ENVIRONMENT.ALL,
  currentEnvironment: Environment = getCurrentEnvironment(),
): boolean => {
  if (environments === ENVIRONMENT.ALL) {
    return true;
  }

  return environments.includes(currentEnvironment);
};

export const FEATURE_FLAGS = {
  domainCopy: enabledIn([
    ENVIRONMENT.LOCALHOST,
    ENVIRONMENT.TEST,
    ENVIRONMENT.STAGING,
    ENVIRONMENT.QDAILY,
    ENVIRONMENT.PREPROD,
  ]),
} satisfies Record<string, boolean>;

export type FeatureFlagName = keyof typeof FEATURE_FLAGS;
